<template>
  <v-app style="width: 100%;">
    <div id="#app">
      <!--navbar top-->
      <toolbar></toolbar>
      <!--content-->
      <main style="background-color: white;min-height:100vh;">
        <v-container id="main-container" fluid>
          <router-view></router-view>
          <back-top>
          </back-top>
        </v-container>
      </main>
      <!--footer-->
      <app-footer></app-footer>
    </div>
  </v-app>
</template>
<script>
  import Toolbar from './sections/Toolbar.vue'
  import Footer from './sections/Footer.vue'
  import BackTop from './sections/BackTop.vue'

  export default {
    name: 'app',
    data() {
      return {
        test: "test"
      };
    },
    created: function () {
      if (getCookie('lang') != "") {
        this.$i18n.locale = getCookie('lang');
        document.documentElement.lang = getCookie('lang');
      }
    },
    components: {
      Toolbar,
      'app-footer': Footer,
      BackTop
    }
  }
</script>
<style lang="stylus">
  @import './stylus/main'
</style>


// WEBPACK FOOTER //
// App.vue?282d97e6